/**
 * Auth0 Configuration Settings for the 9F Twin application.
 * 
 * Replace CLIENT_ID with the actual Client ID from the Auth0 Application Settings.
 */
export const AUTH0_SETTINGS = {
  domain: "auth.9fheaal.com",
  clientId: "soUAxrvtKDyuarJTolIO5G1lK6JKotY1", // Configured with oauth client id
};
